import { render, staticRenderFns } from "./AstaTavoloCerchio.vue?vue&type=template&id=0fe325da&scoped=true&"
import script from "./AstaTavoloCerchio.vue?vue&type=script&lang=js&"
export * from "./AstaTavoloCerchio.vue?vue&type=script&lang=js&"
import style0 from "./AstaTavoloCerchio.vue?vue&type=style&index=0&id=0fe325da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe325da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe325da')) {
      api.createRecord('0fe325da', component.options)
    } else {
      api.reload('0fe325da', component.options)
    }
    module.hot.accept("./AstaTavoloCerchio.vue?vue&type=template&id=0fe325da&scoped=true&", function () {
      api.rerender('0fe325da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaTavoloCerchio.vue"
export default component.exports